import { normalizeCategorySlug } from './public-categories';

/**
 * Questions on a full-length paper: IELTS is 40 Listening + 40 Reading + 2
 * Writing tasks; the Digital SAT is 54 Reading and Writing + 44 Math.
 */
export const FULL_MOCK_QUESTIONS = { ielts: 82, sat: 98 } as const;

type FullMockStandard = keyof typeof FULL_MOCK_QUESTIONS;

/** A full mock has at least IELTS Listening, Reading and Writing, or two SAT modules per subject. */
const FULL_MOCK_MIN_SECTIONS: Record<FullMockStandard, number> = { ielts: 3, sat: 4 };

interface CountedTest {
  category?: string;
  questionsCount: number;
  sectionsCount: number;
}

function fullMockStandard(test: CountedTest): FullMockStandard | null {
  const category = normalizeCategorySlug(test.category);
  if (category !== 'ielts' && category !== 'sat') return null;
  return test.sectionsCount >= FULL_MOCK_MIN_SECTIONS[category] ? category : null;
}

/**
 * The question count a catalog card shows, or undefined when there is none.
 * The API counts the questions in a test's own sections (each sub-question of
 * a reading passage counts), so an IELTS or SAT full mock drawn from the
 * library reads as 0 or 1; a full mock never shows fewer than the real paper.
 */
export function publicQuestionsCount(test: CountedTest): number | undefined {
  const count = test.questionsCount > 0 ? test.questionsCount : 0;
  const standard = fullMockStandard(test);
  if (standard) return Math.max(count, FULL_MOCK_QUESTIONS[standard]);
  return count > 0 ? count : undefined;
}
